import { z } from "zod";
import { expenseSchema } from "./schemaHelper";
type ExpenseFormValues = z.infer<typeof expenseSchema>;

export function createExpenseFormData(values: ExpenseFormValues): FormData {
  const formData = new FormData();

  // Append basic fields
  formData.append("id", values.id?.toString() || "");
  formData.append("date", values.date);
  formData.append("amount", values.amount.toString());
  formData.append("category", values.category.toString());
  formData.append("reimbursedTo", values.reimbursedTo);
  formData.append("description", values.description || "");
  formData.append("branch", values.branch.toString());
  formData.append("reimbursed", values.reimbursed.toString());

  formData.append("payment_method", values.paymentMethod); // Match backend field name

  // Handle items
  const items = values.items;
  if (Array.isArray(items)) {
    items.forEach((item) => {
      formData.append("items", item.toString());
    });
  }

  const billPhotos = values.billPhotos || [];
  if (Array.isArray(billPhotos) && billPhotos.length > 0) {
    const newFiles: File[] = [];
    const existingPhotoIds: number[] = [];

    billPhotos.forEach((photo) => {
      if (photo instanceof File) {
        newFiles.push(photo); // New uploaded files
      } else if (typeof photo === "object" && photo !== null && "id" in photo) {
        existingPhotoIds.push(photo.id); // Existing uploaded photo ids
      }
    });

    if (newFiles.length > 0) {
      newFiles.forEach((file, index) => {
        formData.append(`billPhotoFiles[${index}]`, file);
      });
    }

    existingPhotoIds.forEach((id, index) => {
      formData.append(`existingBillPhotoIds[${index}]`, id.toString());
    });
  }

  return formData;
}
